import React from "react";

import { Button } from "carbon-components-react";
import { CICShape } from "underwriter_dashboard/hurdle_editors/Fees/shared";
import APIClient from "web_modules/APIClient";
import { DisclosureType, DisclosureTypeRecord } from "@eave/shared/types/api";

interface CICButtonProps {
  updateCICLoading: Function;
  selectedCIC: string;
  otherCICDescription: string;
  appId: number;
  locked: boolean;
  notUndisclosedChangeInCircumstance: boolean;
  updateShowCICDeletionModal: Function;
  selectedDisclosure: DisclosureType;
}

const CICButton: React.FC<CICButtonProps> = ({
  updateCICLoading,
  selectedCIC,
  otherCICDescription,
  appId,
  locked,
  notUndisclosedChangeInCircumstance,
  updateShowCICDeletionModal,
  selectedDisclosure,
}) => {
  const isLoanEstimate = selectedDisclosure === DisclosureType.LoanEstimate;
  const disabled = (isLoanEstimate && selectedCIC === "") || !locked;

  return notUndisclosedChangeInCircumstance ? (
    <Button
      onClick={() => {
        updateCICLoading(true);

        const cicPayload: CICShape = {
          code: selectedCIC,
          other_description: otherCICDescription,
          fee_section: DisclosureTypeRecord[selectedDisclosure],
        };

        if (selectedCIC !== "Other") {
          delete cicPayload.other_description;
        }

        APIClient.post(`/uw/loan_applications/${appId}/change_in_circumstance`, cicPayload).then(
          () => {
            window.location.reload();
          },
        );
      }}
      disabled={disabled}
      kind="secondary"
    >
      {isLoanEstimate ? "Confirm & Unlock Editing" : "Save CIC"}
    </Button>
  ) : (
    <Button
      kind="secondary"
      onClick={() => updateShowCICDeletionModal(true)}
      disabled={locked && selectedCIC === ""}
    >
      Clear Current CIC
    </Button>
  );
};

export default CICButton;
